<template>
  <article class="fullpage">
    <profile />
  </article>
</template>

<script>
import { profile } from '@/components/advisor';
import getBrandConfig from '@/lib/utils/get_brand_config';

const brandConfig = getBrandConfig();

export default {
  head() {
    const title = this.$t('Profile');
    return {
      title: `${title} | ${brandConfig.fullName}`,
    };
  },
  components: { profile },
};
</script>
